import { render, staticRenderFns } from "./MiniSwatch.vue?vue&type=template&id=59b595a9&scoped=true&"
import script from "./MiniSwatch.vue?vue&type=script&lang=ts&"
export * from "./MiniSwatch.vue?vue&type=script&lang=ts&"
import style0 from "./MiniSwatch.vue?vue&type=style&index=0&id=59b595a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b595a9",
  null
  
)

export default component.exports